import { render, staticRenderFns } from "./middle-bottom.vue?vue&type=template&id=2967a2c8&scoped=true&"
import script from "./middle-bottom.vue?vue&type=script&lang=js&"
export * from "./middle-bottom.vue?vue&type=script&lang=js&"
import style0 from "./middle-bottom.vue?vue&type=style&index=0&id=2967a2c8&scoped=true&lang=css&"
import style1 from "./middle-bottom.vue?vue&type=style&index=1&id=2967a2c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967a2c8",
  null
  
)

export default component.exports